var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title-container"},[_c('h3',[_vm._v("Agenda")])])]),_c('div',{staticClass:"cards-container"})])
}]

export { render, staticRenderFns }